import { ApplicationRef, Injectable, Injector, NgZone } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    private countRequest = 0;
    constructor(private injector: Injector) {}

    private get progressBar(): FuseProgressBarService {
        return this.injector.get(FuseProgressBarService);
    }

    private get appRef(): ApplicationRef {
        return this.injector.get(ApplicationRef);
    }

    private get ngZone(): NgZone {
        return this.injector.get(NgZone);
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!this.countRequest) {
            this.progressBar.show();
        }
        this.countRequest++;
        return next.handle(request).pipe(
            finalize(() => {
                this.countRequest--;
                if (!this.countRequest) {
                    this.progressBar.hide();
                }
                // Ensure views refresh after async HTTP assigns plain component fields
                // (Angular 21+/22 CD gaps until all pages use signals).
                this.ngZone.run(() => {
                    queueMicrotask(() => this.appRef.tick());
                });
            })
        );
    }
}
